define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var AcWrapper = require('web-agent-utils/AcWrapper');

    lpTag.lpCannedResponsesController = function (model) {
        var cannedResponses = {};
        this.applicationType = "lpCannedResponsesController";
        var cannedResponsesACWrapper, categoriesACWrapper;
        var cannedResponsesData, categoriesData;
        var cannedResponsesRetries = 0;
        var categoriesRetries = 0;
        var cannedResponsesDataParams = {select:"$all", group_by : "CATEGORIES"};
        var categoriesDataParams = {select: "$all"};
        var logger = WebAgentLogger.getLogger(this.applicationType);
        var logicController = lpTag.WebAgent.logicController;

        var dataStates = {
            fetching: 'fetching',
            success: 'success',
            error: 'error'
        };

        initializeACWrappers();
        buildCannedResponsesDataModel();

        function initializeACWrappers() {
            var acKeys = agentLEManager.getLEUrlResolverApiResourcesService("AccountConfig");
            if (acKeys && acKeys.CannedMessages && acKeys.Categories) {
                cannedResponsesACWrapper = AcWrapper.createInstance(acKeys.CannedMessages, "CannedMessages");
                categoriesACWrapper = AcWrapper.createInstance(acKeys.Categories, "Categories");
                this.languages = getSupportedLanguages() || "";
                cannedResponsesDataParams.lang = this.languages;
            }
        }

        cannedResponses.fetchData = function (chatId) {
            cannedResponsesRetries = 0;
            buildCannedResponsesDataModel(chatId);
        };

        function getSupportedLanguages() {
            var languagesString;
            var supportedLanguagesArray = agentLEManager.getSupportedLanguageCodes();
            if (supportedLanguagesArray && supportedLanguagesArray.length > 0) {
                languagesString = supportedLanguagesArray.join(",");
            }
            return languagesString;
        }

        function buildCannedResponsesDataModel(chatId) {
            var skillIds, cannedResponseRequest, categoriesRequest, currentState;
            logger.info("Send request", "handleCannedResponseData");

            if (!chatId) {
                return;
            }

            if (cannedResponsesACWrapper && categoriesACWrapper) {

                cannedResponseRequest = {
                    success: handleCannedResponsesSuccess,
                    error: handleCannedResponsesError,
                    data: cannedResponsesDataParams,
                    splitRevisionBy: 'query'
                };
                categoriesRequest = {
                    success: handleCategoriesSuccess,
                    error: handleCategoriesError,
                    data: categoriesDataParams,
                    splitRevisionBy: 'query'
                };

                skillIds = logicController.getChatSkillIds(chatId);
                if (skillIds && skillIds.length) {
                    cannedResponseRequest.query = "skill_ids=" + skillIds.join(',');
                }

                var requestSkill = _getSkillIdTextFromList(skillIds);
                var requestState = model.get('preDefinedContent.' + requestSkill + '.state');

                if (requestState !== dataStates.fetching) {
                    cannedResponsesACWrapper.getValue(cannedResponseRequest);
                    categoriesACWrapper.getValue(categoriesRequest);
                    model.set('preDefinedContent.' + requestSkill + '.state', dataStates.fetching);
                }

                currentState = model.get("preDefinedContent.state");
                if (!currentState || currentState === dataStates.error) {
                    model.set("preDefinedContent.state", dataStates.fetching);
                }
            }

            function handleCannedResponsesSuccess(data) {
                logger.info("CannedResponses return as Success", "handleCannedResponsesSuccess");
                if (data.body && !_.isEmpty(data.body)) {
                    handleCannedResponseData(data.body);
                } else if (data.responseCode !== 304) {
                    handleCannedResponseData({});
                } else {
                    model.set('preDefinedContent.' + requestSkill + '.state', dataStates.success);
                }
            }

            function handleCannedResponsesError(errorData) {
                logger.error("", "handleCannedResponsesError", errorData);
                logger.graph({name: 'cannedResponsesError'});
                var cannedResponses = {};
                cannedResponses.error = errorData;
                handleCannedResponseData(cannedResponses);
            }

            function handleCannedResponseData(cannedResponses) {
                if (cannedResponses && cannedResponses.error) {
                    // retrying to retrieve the data for 3 times
                    if(cannedResponsesRetries < 3){
                        ++cannedResponsesRetries;
                        cannedResponsesACWrapper.getValue({ success : handleCannedResponsesSuccess, error : handleCannedResponsesError, data : cannedResponsesDataParams });
                    } else {
                        logger.error("", "handleCannedResponseData", cannedResponses);
                        logger.graph({name: 'cannedResponsesDataError'});
                        model.set("preDefinedContentError", true);
                        model.set("preDefinedContent.state", dataStates.error);
                        model.set('preDefinedContent.' + requestSkill + '.state', dataStates.error);
                    }
                } else {
                    logger.debug("", "handleCannedResponseData", cannedResponses);
                    model.set("preDefinedContentError", false);
                    cannedResponsesRetries = 0;
                    buildCannedResponsesData(cannedResponses);
                    createPredefinedContent();
                }
            }

            function buildCannedResponsesData(cannedResponses) {
                cannedResponsesData = [];
                if (cannedResponses) {
                    for (var categoryId in cannedResponses) {
                        if (cannedResponses.hasOwnProperty(categoryId)) {
                            var categoryData = {items: {item: []}, title: ""};
                            modifyCategoryItems(cannedResponses[categoryId]);
                            categoryData.items.item = cannedResponses[categoryId];
                            categoryData.categoryId = categoryId;
                            categoryData.title = agentLEManager.translateLE("LEWebAgent.uncategorized");
                            cannedResponsesData.push(categoryData);
                        }
                    }
                }
            }

            function handleCategoriesSuccess(data) {
                if (data.body && !_.isEmpty(data.body)) {
                    handleCategoriesData(data.body);
                } else if (data.responseCode !== 304) {
                    handleCategoriesData({});
                }
            }

            function handleCategoriesError(errorData) {
                var categories = {};
                categories.error = errorData;
                handleCategoriesData(categories);
            }

            function handleCategoriesData(categories) {
                if (categories && categories.error) {
                    //// retrying to retrieve the data for 3 times
                    if (categoriesRetries < 3) {
                        ++categoriesRetries;
                        categoriesACWrapper.getValue({ success: handleCategoriesSuccess, error: handleCategoriesError, data: categoriesDataParams});
                    } else {
                        logger.error("", "handleCategoriesData", categories);
                        logger.graph({name: 'categoriesDataError'});
                    }
                } else {
                    logger.debug("", "handleCategoriesData", categories);
                    categoriesData = convertCategoriesToMap(categories);
                    createPredefinedContent();
                }
            }

            function createPredefinedContent() {
                if (cannedResponsesData && categoriesData) {
                    addCategoryTitles();
                    var predefinedContentByLang = createPredefinedContentByLang();
                    addCategoryIdToPRedefinedContent(predefinedContentByLang);
                    predefinedContentByLang.state = dataStates.success;
                    predefinedContentByLang.shortcuts = getShortcuts();
                    var skillId = _getSkillIdTextFromList(skillIds);
                    model.set('preDefinedContent.' + skillId, predefinedContentByLang);
                }
            }

            function _getSkillIdTextFromList(skillIds) {
                return (skillIds && skillIds.length) ? skillIds.join('_') : 'unSkillChat';
            }

            function addCategoryIdToPRedefinedContent(predefinedContentByLang) {
                // Here we go over all the category IDs (in categoriesData) and put the IDs in the predefinedContentByLang
                // According to their order, for each language.
                for (var lang in predefinedContentByLang) {
                    for (var categoryId in categoriesData) {
                        if (predefinedContentByLang[lang][categoriesData[categoryId].order - 1] !== undefined) {
                            predefinedContentByLang[lang][categoriesData[categoryId].order - 1].categoryId = categoryId;
                        }
                    }
                }

            }

            function createPredefinedContentByLang() {
                var predefinedContentByLang = {};
                var sortFunctionByTitle = lpUtils.getSortFunction('title');
                var sortFunctionByOrder = lpUtils.getSortFunction('order');
                var languages = agentLEManager.getSupportedLanguageCodes();
                var unassignedCatName = agentLEManager.translateLE("LEWebAgent.uncategorized");

                // todo - WTF 5 levels of nesting ?!?!?!?

                // Going over the languages
                for (var langIdx = 0; langIdx < languages.length; ++langIdx) {
                    var currPredefinedContentByLang = [];
                    var currUnassignedCategory = null;
                    var lang = languages[langIdx];

                    // Going over the categories
                    for (var catIdx = 0; catIdx < cannedResponsesData.length; ++catIdx) {
                        var currCategory = cannedResponsesData[catIdx];
                        var categoryToAdd = {items : {item : []}, skill : {} , title : currCategory.title, order : currCategory.order};

                        if (currCategory && (currCategory.isDefault || unassignedCatName === categoryToAdd.title) &&
                            currCategory.items && currCategory.items.item) {
                            for (var itemIdx = 0; itemIdx < currCategory.items.item.length; ++itemIdx) {
                                var currItem = currCategory.items.item[itemIdx];
                                if (currItem.data && currItem.data[lang] && currItem.enabled && !currItem.deleted) {
                                    var itemToAdd = {   enable : currItem.enabled,
                                                        format: "text",   //TODO: support other content types
                                                        hotKey : currItem.hotkey,
                                                        text : currItem.data[lang].msg,
                                                        title : currItem.data[lang].title,
                                                        skillsIds:currItem.skillIds,
                                                        currentLineId:currItem.id,
                                                        categoryId: Number(currCategory.categoryId)
                                    };
                                    categoryToAdd.items.item.push(itemToAdd);
                                }
                            }
                        }

                        if (categoryToAdd.items.item.length > 0) {
                            categoryToAdd.items.item.sort(sortFunctionByTitle);

                            // Saving the unassigned category so we only add it at the end of sorting
                            if (unassignedCatName === categoryToAdd.title) {
                                currUnassignedCategory = categoryToAdd;
                            } else {
                                currPredefinedContentByLang.push(categoryToAdd);
                            }
                        }
                    }
                    if (currPredefinedContentByLang.length > 0 || currUnassignedCategory) {
                        currPredefinedContentByLang.sort(sortFunctionByOrder);

                        // Adding the unassigned category after sorting so it will appear in the end
                        if (currUnassignedCategory) {
                            currPredefinedContentByLang.push(currUnassignedCategory);
                        }
                        predefinedContentByLang[lang] = currPredefinedContentByLang;
                    }
                }
                return predefinedContentByLang;
            }

            function getShortcuts() {
                var unassignedCatName = agentLEManager.translateLE("LEWebAgent.uncategorized");
                var retVal = [];

                // todo - WTF 5 levels of nesting again ?!?!?!?

                for (var catIdx = 0; catIdx < cannedResponsesData.length; ++catIdx) {
                    var currCategory = cannedResponsesData[catIdx];
                    if (currCategory && currCategory.items && currCategory.items.item) {
                        if (currCategory.isDefault || unassignedCatName === currCategory.title) {
                            for (var itemIdx = 0; itemIdx < currCategory.items.item.length; ++itemIdx) {
                                var currItem = currCategory.items.item[itemIdx];
                                if (currItem.hotkey && currItem.enabled && !currItem.deleted) {
                                    retVal.push(currItem);
                                }
                            }
                        }
                    }
                }
                return retVal;
            }

            function addCategoryTitles() {
                for (var idx = 0; idx < cannedResponsesData.length; ++idx) {
                    var cannedResponsesCategory = cannedResponsesData[idx];
                    if (cannedResponsesCategory.categoryId) {
                        if (categoriesData.hasOwnProperty(cannedResponsesCategory.categoryId)) {
                            cannedResponsesCategory.title = categoriesData[cannedResponsesCategory.categoryId].name;
                            cannedResponsesCategory.isDefault = categoriesData[cannedResponsesCategory.categoryId].proposed;
                            cannedResponsesCategory.order = categoriesData[cannedResponsesCategory.categoryId].order;
                        }
                    }
                }
            }

            function convertCategoriesToMap(categories) {
                var retVal = {};
                if (categories) {
                    for (var idx = 0; idx < categories.length; ++idx) {
                        var category = categories[idx];
                        if (!category.deleted) {
                            retVal[category.id] = category;
                        }
                    }
                }
                return retVal;
            }

            function modifyCategoryItems(categoryItems) {
                for (var i = 0; i < categoryItems.length; i++) {
                    modifyCategoryItem(categoryItems[i]);
                }
            }

            function modifyCategoryItem(categoryItem) {
                var itemDataByLang = {};
                if (categoryItem.data) {
                    for (var i = 0; i < categoryItem.data.length; i++) {
                        if (categoryItem.data[i].title && categoryItem.data[i].msg) {
                            itemDataByLang[categoryItem.data[i].lang] = categoryItem.data[i];
                        }
                    }
                    categoryItem.data = itemDataByLang;
                }
            }
        }
        return cannedResponses;
    };

    return lpTag.lpCannedResponsesController;

});
